import axios from 'axios';
import config from '../config';

const formDataApi = axios.create({
    baseURL: config.baseUrl,
    headers: {
        'APP_NAME': config.app_name,
        'APP_VERSION': config.version,
		'Content-Type': 'multipart/form-data'
    }
});

formDataApi.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token');
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		} else {
			delete config.headers['Authorization'];
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export default formDataApi;
